module.exports = __webpack_public_path__ + "img/loading_dark.1d6ca8ca.svg";